import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ReadJsonForm from '../forms/read-json-form';
import { jsonReaderSchema } from '../schema/json.js';

export default function ReadJsonNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Read JSON Node Details',
        altText: 'Read JSON Node',
        defaultLabel: 'Read JSON Node',
      }}
    >
      <CommonNode FormComponent={ReadJsonForm} schemaResolver={jsonReaderSchema} />
    </NodeProvider>
  );
}
